<template>
  <section
    class="sidearm-mm-results sidearm-mm-results--mobile text-white relative bg-size-cover bg-position-center relative minh-100"
    data-anchor="gameday"
  >
    <section-background css_var="--section-desktop-bg-selection-sunday-results"></section-background>
    <video-background
      v-if="section.background_type === 'video'"
      :video="section.background_video"
    />
    <div class="sidearm-mm-results-seed slide ">
      <div
        scrolling
        class="sidearm-mm-results__intro w-100 h-100 relative pb-6 flex flex-align-start flex-justify-end flex-column"
        v-touch:swipe.prevent="preventDesktop(swipe)"
      >
        <transition
          :name="panel_transition"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:before-leave="beforeLeave"
          v-on:leave="leave"
        >
          <h2
            v-show="swipe_step < 3"
            class="type-heading-bracket-plain --light mt-0 mb-1 mx-4"
          >
            Selection {{ this.$root.selection_day_text }}
          </h2>
        </transition>
        <transition
          :name="panel_transition"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:before-leave="beforeLeave"
          v-on:leave="leave"
        >
          <div v-show="swipe_step <= 1" class="sidearm-mm-results__intro-panel">
            <h3 v-if="$root.data.team && $root.data.team.seed" class="type-hero mt-0 mb-4 mx-4">
              #{{ $root.data.team.seed }} Seed
            </h3>
          </div>
        </transition>
        <transition
          :name="panel_transition"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:before-leave="beforeLeave"
          v-on:leave="leave"
        >
          <div
            v-show="swipe_step === 1 || (swipe_step === 2 && section.sub_title)"
            class="sidearm-mm-results__intro-panel"
          >
            <p v-if="section.sub_title" class="type-paragraph  ma-0 w-100 pa-2">
              {{ section.sub_title }}
            </p>
          </div>
        </transition>
        <transition
          :name="panel_transition"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:before-leave="beforeLeave"
          v-on:leave="leave"
        >
          <div
            v-show="swipe_step === 2"
            class="sidearm-mm-results__intro-panel"
          >
            <button
              v-if="$root.upcoming_game"
              @click="moveSlideRight"
              class="sidearm-mm-btn --ghost mx-4"
            >
              Gameday Experience <icon>sf-arrows-thick-right --hint</icon>
            </button>
          </div>
        </transition>
        <transition
          :name="panel_transition"
          v-on:before-enter="beforeEnter"
          v-on:enter="enter"
          v-on:before-leave="beforeLeave"
          v-on:leave="leave"
        >
          <div
            v-show="swipe_step === 3"
            class="sidearm-mm-results__bracket absolute w-100"
          >
            <matchup-bracket-mobile
              v-if="$root.upcoming_game"
              :round="$root.upcoming_game"
            >
              <div
                v-if="$root.upcoming_game"
                class="sidearm-mm-gameday-preview__info-table border-primary-a mt-3 mb-4"
              >
                <div class="flex border-primary-b">
                  <div class="px-2 py-1 flex-item-1 border-primary-r">
                    {{
                      moment($root.upcoming_game.game.date).format(
                        "MMM D, YYYY"
                      )
                    }}
                  </div>
                  <div class="px-2 py-1 flex-item-auto">
                    {{
                      $root.upcoming_game.game.tbd
                        ? "TBD"
                        : moment($root.upcoming_game.game.date).format("h:mm A")
                    }}
                  </div>
                </div>
                <div
                  v-if="$root.upcoming_game.game.location"
                  class="py-1 px-2 text-bold"
                >
                  {{ $root.upcoming_game.game.location }}
                </div>
              </div>
              <div class="mb-4">
                <game-media :game="$root.upcoming_game.game"></game-media>
              </div>
            </matchup-bracket-mobile>
          </div>
        </transition>
      </div>
    </div>

    <div v-if="$root.upcoming_game" class="slide">
      <div
        class="sidearm-mm-results__intro w-100 h-100 relative pb-6 flex flex-align-start flex-justify-end flex-column"
        v-touch:swipe.prevent="preventDesktop(swipe)"
      >
        <matchup-bracket-mobile
          v-if="$root.upcoming_game"
          :round="$root.upcoming_game"
        >
          <div
            v-if="$root.upcoming_game"
            class="sidearm-mm-gameday-preview__info-table border-primary-a mt-3 mb-4"
          >
            <div class="flex border-primary-b">
              <div class="px-2 py-1 flex-item-1 border-primary-r">
                {{
                  moment($root.upcoming_game.game.date).format(
                    "MMM D, YYYY"
                  )
                }}
              </div>
              <div class="px-2 py-1 flex-item-auto">
                {{
                  $root.upcoming_game.game.tbd
                    ? "TBD"
                    : moment($root.upcoming_game.game.date).format("h:mm A")
                }}
              </div>
            </div>
            <div
              v-if="$root.upcoming_game.game.location"
              class="py-1 px-2 text-bold"
            >
              {{ $root.upcoming_game.game.location }}
            </div>
          </div>
          <div class="mb-4">
            <game-media :game="$root.upcoming_game.game"></game-media>
          </div>
        </matchup-bracket-mobile>
      </div>
    </div>

    <div v-if="$root.upcoming_game" class="slide">
      <matchup-overview-mobile :round="$root.upcoming_game" />
    </div>
  </section>
</template>

<script>
import MatchupBracketMobile from "@/components/MatchupBracketMobile";
import MatchupOverviewMobile from "@/components/MatchupOverviewMobile";
import GameMedia from "@/components/GameMedia";

export default {
  components: {
    MatchupBracketMobile,
    MatchupOverviewMobile,
    GameMedia
  },

  data: () => ({
    swipe_step: 0,
    swipe_direction: "",
    panel_transition: "down"
  }),
  methods: {
    swipe(direction) {
      this.swipe_direction = direction;
      if (direction === "left") {
        this.swipeLeft();
      }
      if (direction === "bottom") {
        this.swipeUp();
      }
      if (direction === "top") {
        this.swipeDown();
      }
    },

    swipeLeft() {
      this.moveSlideRight();
    },

    swipeDown() {
      if (this.swipe_step >= this.swipe_intervals) {
        this.moveSectionDown();
      } else {
        this.panel_transition = "down";
        if (this.swipe_step === 0 && !this.section.sub_title) {
          this.swipe_step++;
        }
        this.swipe_step++;
      }
    },

    swipeUp() {
      if (this.swipe_step === 0) {
        this.moveSectionUp();
      } else {
        this.panel_transition = "up";
        if (this.swipe_step === 2 && !this.section.sub_title) {
          this.swipe_step--;
        }
        this.swipe_step--;
      }
    },
    beforeEnter: function(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    leave: function(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    }
  },

  computed: {
    section() {
      if (!this.$root.data) {
        return null;
      }

      return this.$root.data.selection_sunday_section;
    },

    round() {
      if (!this.$root.data) {
        return null;
      }

      if (this.$root.data.team.first_four) {
        return this.$root.data.tournament_section.r68;
      }

      return this.$root.data.tournament_section.r64;
    },
    swipe_intervals() {
      let _intervals = 0;
      if (this.section.sub_title) {
        _intervals++;
      }
      if (this.round) {
        _intervals++;
      }
      if (this.$root.upcoming_game) {
        _intervals++;
      }
      return _intervals;
    }
  }
};
</script>

<style lang="scss" scoped>
.sidearm-mm-results {
  &__divider {
    > span {
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }

    &::before {
      border-bottom: 1px solid $color-white;
      border-right: 1px solid $color-white;
      bottom: 50%;
      content: "";
      display: block;
      height: 100vh;
      left: 1.5rem;
      position: absolute;
      width: calc(100% - 1.5rem);
    }
  }
  &__intro {
    z-index: 2;
    height: 100vh;
  }
  &__intro-panel {
    transition: 0.5s;
  }
  &__intro-panel--bracket {
    bottom: 0;
  }

  &__bracket {
    padding-top: 90vh;
    overflow: hidden;
  }
  &__bracket-inner {
    transform: translateY(10vh);
    transition: 0.3s;
    &.active {
      transform: none;
    }
  }
}

.up-enter {
  transform: translateY(-5vh);
}
.up-leave-to {
  transform: translateY(5vh);
}

.down-enter {
  transform: translateY(5vh);
}
.down-leave-to {
  transform: translateY(-5vh);
}
</style>
